import React, { Fragment } from 'react';
import { FieldArray } from '../../../libs/reduxForm';
import PropTypes from 'prop-types';
import ShareholderCompanyInputGroup from './ShareholderCompanyFieldGroup';
import ShareholderIndividualInputGroup from './ShareholderIndividualFieldGroup';
import './FormField.css';

var ArrayComponent = function ArrayComponent(_ref) {
  var fields = _ref.fields,
      AddButton = _ref.AddButton,
      RemoveButton = _ref.RemoveButton,
      user = _ref.user;
  return React.createElement(Fragment, null, fields.map(function (fieldName, index) {
    var field = fields.get(index);
    var type = field.type;
    var InputGroup = type && type.toLowerCase().indexOf('company') > -1 ? ShareholderCompanyInputGroup : ShareholderIndividualInputGroup;
    return React.createElement('div', {
      key: fieldName
    }, React.createElement('h2', {
      className: 'align-items-center'
    }, type, ' ', React.createElement(RemoveButton, {
      fields: fields,
      index: index
    })), React.createElement(InputGroup, {
      name: fieldName,
      user: user
    }));
  }), React.createElement(AddButton, {
    fields: fields
  }));
};

var ShareholderArrayField = function ShareholderArrayField(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      AddButton = _ref2.AddButton,
      RemoveButton = _ref2.RemoveButton,
      user = _ref2.user;
  return React.createElement('div', {
    className: 'form-group'
  }, label && React.createElement('label', {
    className: 'control-label'
  }, label), React.createElement(FieldArray, {
    name: name,
    component: ArrayComponent,
    AddButton: AddButton,
    RemoveButton: RemoveButton,
    user: user
  }));
};

ShareholderArrayField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  AddButton: PropTypes.func.isRequired,
  RemoveButton: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};
export default ShareholderArrayField;